export default __webpack_public_path__ + "static/Ebook-sol-book-518bbdce35d4ba04dfa9049589f35a10.png";